var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefit3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.703,
    height: 22.974,
    viewBox: "0 0 30.703 22.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936",
    transform: "translate(-5 -23.36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153162",
    "data-name": "Rectangle 153162",
    width: 1.561,
    height: 1.242,
    transform: "translate(10.674 38.522)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89815",
    "data-name": "Path 89815",
    d: "M13.454,60.305H5v.244a.545.545,0,0,0,.544.544h7.91v-.788Z",
    transform: "translate(0 -24.341)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153163",
    "data-name": "Rectangle 153163",
    width: 1.561,
    height: 1.242,
    transform: "translate(7.31 38.522)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89816",
    "data-name": "Path 89816",
    d: "M40.342,87.656H25.2A1.4,1.4,0,0,0,23.849,88.7H41.692A1.4,1.4,0,0,0,40.342,87.656Z",
    transform: "translate(-12.419 -42.362)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153164",
    "data-name": "Rectangle 153164",
    width: 1.561,
    height: 1.242,
    transform: "translate(28.469 38.522)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89817",
    "data-name": "Path 89817",
    d: "M70.219,61.093h7.91a.545.545,0,0,0,.544-.544v-.244H70.219Z",
    transform: "translate(-42.97 -24.341)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89818",
    "data-name": "Path 89818",
    d: "M70.219,70.07h.79a.357.357,0,0,1,.356.356v1.4h6.216V64.705H70.219Zm3.871-4.664a.356.356,0,0,1,.357-.357H76.72a.357.357,0,0,1,.356.357v1.955a.356.356,0,0,1-.356.357H74.446a.357.357,0,0,1-.357-.357Zm-3.364,0a.356.356,0,0,1,.356-.357h2.274a.357.357,0,0,1,.356.357v1.955a.356.356,0,0,1-.356.357H71.082a.357.357,0,0,1-.356-.357Z",
    transform: "translate(-42.97 -27.24)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153165",
    "data-name": "Rectangle 153165",
    width: 1.561,
    height: 1.242,
    transform: "translate(31.833 38.522)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89819",
    "data-name": "Path 89819",
    d: "M14.416,70.427a.356.356,0,0,1,.356-.356h.79V64.705H8.2v7.117h6.216v-1.4Zm-2.724-3.065a.356.356,0,0,1-.356.356H9.061a.357.357,0,0,1-.356-.356V65.406a.356.356,0,0,1,.356-.356h2.274a.357.357,0,0,1,.356.356Zm.377,0V65.406a.356.356,0,0,1,.356-.356H14.7a.357.357,0,0,1,.356.356v1.955a.356.356,0,0,1-.356.356H12.425A.357.357,0,0,1,12.069,67.362Z",
    transform: "translate(-2.108 -27.24)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153166",
    "data-name": "Rectangle 153166",
    width: 2.205,
    height: 0.542,
    transform: "translate(19.249 41.201)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153167",
    "data-name": "Rectangle 153167",
    width: 2.205,
    height: 1.796,
    transform: "translate(15.227 37.464)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153168",
    "data-name": "Rectangle 153168",
    width: 2.205,
    height: 1.796,
    transform: "translate(19.249 37.464)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153169",
    "data-name": "Rectangle 153169",
    width: 2.205,
    height: 0.542,
    transform: "translate(23.271 41.201)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89820",
    "data-name": "Path 89820",
    d: "M44.26,38.64a1.958,1.958,0,1,0,1.958-1.958A1.96,1.96,0,0,0,44.26,38.64Z",
    transform: "translate(-25.867 -8.777)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153170",
    "data-name": "Rectangle 153170",
    width: 2.205,
    height: 0.542,
    transform: "translate(15.227 41.201)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153171",
    "data-name": "Rectangle 153171",
    width: 2.205,
    height: 1.796,
    transform: "translate(23.271 37.464)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9494",
    "data-name": "Ellipse 9494",
    cx: 0.801,
    cy: 0.801,
    r: 0.801,
    transform: "translate(19.551 33.649)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89822",
    "data-name": "Path 89822",
    d: "M34.626,24.23a.356.356,0,0,1,.252.1l6.789,6.788a.87.87,0,0,0,.92.2L34.627,23.36l-7.961,7.961a.869.869,0,0,0,.92-.2l6.788-6.789a.355.355,0,0,1,.252-.1Z",
    transform: "translate(-14.275)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89823",
    "data-name": "Path 89823",
    d: "M31.869,34.62V46.174h12.37V34.62l-6.185-6.185L31.869,34.62Zm3.978,10.824a.356.356,0,0,1-.356.356H32.573a.357.357,0,0,1-.356-.356V44.189a.356.356,0,0,1,.356-.356h2.918a.357.357,0,0,1,.356.356Zm0-2.482a.356.356,0,0,1-.356.356H32.573a.357.357,0,0,1-.356-.356V40.452a.356.356,0,0,1,.356-.356h2.918a.357.357,0,0,1,.356.356Zm4.022,2.482a.356.356,0,0,1-.357.356H36.6a.357.357,0,0,1-.356-.356V44.189a.356.356,0,0,1,.356-.356h2.918a.357.357,0,0,1,.357.356ZM36.6,40.1h2.917a.357.357,0,0,1,.357.356v2.509a.356.356,0,0,1-.357.356H36.6a.357.357,0,0,1-.356-.356V40.452A.356.356,0,0,1,36.6,40.1Zm-.055-2.3a1.514,1.514,0,1,1,1.514,1.514A1.515,1.515,0,0,1,36.54,37.794Zm7.351,7.65a.356.356,0,0,1-.356.356H40.617a.357.357,0,0,1-.356-.356V44.189a.356.356,0,0,1,.356-.356h2.918a.357.357,0,0,1,.356.356Zm0-4.992v2.509a.356.356,0,0,1-.356.356H40.617a.357.357,0,0,1-.356-.356V40.452a.356.356,0,0,1,.356-.356h2.918A.357.357,0,0,1,43.892,40.452Zm-3.167-7.245a2.671,2.671,0,1,1-2.671-2.671A2.674,2.674,0,0,1,40.725,33.207Z",
    transform: "translate(-17.703 -3.344)",
    fill: "#5476ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89824",
    "data-name": "Path 89824",
    d: "M28.511,83.56H43.173V82.521H28.511Z",
    transform: "translate(-15.49 -38.978)",
    fill: "#5476ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit3);
export default __webpack_public_path__ + "static/media/Benefit_3.5115ce7c4ca99115aec968a61f96d370.svg";
export { ForwardRef as ReactComponent };